export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:chunkError', () => {
    // Expected, self-healing behavior: after a deploy the old hashed chunks are
    // gone, so stale tabs fail to lazy-load them. Nuxt reloads the page
    // automatically (see emitRouteChunkError in nuxt.config), so this is noise
    // rather than an actionable error.
    useLogger().warn('Caught chunk load issue, page will reload')
  })
})
